import request from '@/utils/http'
// 查询公司列表
export function getCompanyList (data) {
  return request({
    method: 'POST',
    url: '/rest/house/industry/listCompany',
    data
  })
}
// 查询行业分类
export function getIndustryList (data) {
  return request({
    method: 'POST',
    url: '/rest/house/dictionary/queryDictionariesByType',
    data
  })
}
// 查询公司简介
export function getCompanyIntroduction (data) {
  return request({
    method: 'POST',
    url: '/rest/house/industry/queryCompanyIntroduction',
    data
  })
}
// 查询公司联系方式
export function getCompanyContact (data) {
  return request({
    method: 'POST',
    url: '/rest/house/industry/queryCompanyContact',
    data
  })
}
// 查询公司荣誉
export function getCompanyHonor (data) {
  return request({
    method: 'POST',
    url: '/rest/house/industry/queryCompanyHonor',
    data
  })
}
// 查询公司优秀案列
export function getExcellentCase (data) {
  return request({
    method: 'POST',
    url: '/rest/house/industry/queryExcellentCase',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/layout/index.js